const jsbiShim = {
    // constructor
    BigInt: BigInt,
    // note: JSBI toString is already the same: a.toString()
    toNumber: Number,
    // binary functions to expressions
    add: (a, b) => a + b,
    subtract: (a, b) => a - b,
    multiply: (a, b) => a * b,
    divide: (a, b) => a / b,
    remainder: (a, b) => a % b,
    exponentiate: (a, b) => a ** b,
    leftShift: (a, b) => a << b,
    signedRightShift: (a, b) => a >> b,
    bitwiseAnd: (a, b) => a & b,
    bitwiseOr: (a, b) => a | b,
    bitwiseXor: (a, b) => a ^ b,
    equal: (a, b) => a === b,
    notEqual: (a, b) => a !== b,
    lessThan: (a, b) => a < b,
    lessThanOrEqual: (a, b) => a <= b,
    greaterThan: (a, b) => a > b,
    greaterThanOrEqual: (a, b) => a >= b,
    EQ: (a, b) => a == b,
    NE: (a, b) => a != b,
    LT: (a, b) => a < b,
    LE: (a, b) => a <= b,
    GT: (a, b) => a > b,
    GE: (a, b) => a >= b,
    ADD: (a, b) => a + b,
    // unary functions to expressions
    unaryMinus: (a) => -a,
    bitwiseNot: (a) => ~a,
    // static methods
    asIntN: (a, b) => BigInt.asIntN(a, b),
    asUintN: (a, b) => BigInt.asUintN(a, b),
};
if (!self.BigInt && !self.JSBI) {
    throw new Error('BigInt is not supported in this browser.' +
        ' Conflux is unable to create zip files without BigInt support, or a JSBI polyfill.');
}
/**
 * Use JSBI syntax for BigInt operations, instead of calling BigInt directly.
 *
 * This is NOT a polyfill. It uses native BigInt by default. Using this syntax simply makes it _possible_ to polyfill BigInt.
 * If BigInt is not natively supported (ES2020+), library consumer MUST expose globalThis.JSBI before using Conflux.
 *
 * @see https://github.com/GoogleChromeLabs/jsbi - JSBI library for why BigInt
 * @see https://github.com/GoogleChromeLabs/jsbi/blob/master/jsbi.d.ts - types
 */
export const JSBI = !self.BigInt && self.JSBI ? self.JSBI : jsbiShim;
//# sourceMappingURL=bigint.js.map